import { useConfigurationContext } from 'Configuration/useConfigurationContext';

export const useIsDetailedDesktopTileEnabled = () => {
	const configurationService = useConfigurationContext().configurationService;
	return configurationService.detailedDesktopConfiguration.isDetailedDesktopTileEnabled();
};
